import React, { useCallback } from 'react';
import type { TaxStatusEnum } from 'venn-api';
import SimpleFilter from './SimpleFilter';
import { cn } from '@/lib/utils';

const fieldName = 'Tax Status';

const TAX_STATUS_OPTIONS: { label: string; value: TaxStatusEnum }[] = [
  { label: 'Taxable', value: 'TAXABLE' },
  { label: 'Tax-deferred', value: 'TAX_DEFERRED' },
  { label: 'Tax-exempt', value: 'TAX_EXEMPT' },
];

interface TaxStatusFilterProps {
  className?: string;
  onFilter: (updated: TaxStatusEnum[]) => void;
  selected: TaxStatusEnum[];
  closeOnOnlyClick?: boolean;
  isAdvanced?: boolean;
}

const TaxStatusFilter = ({ className, selected, onFilter, closeOnOnlyClick, isAdvanced }: TaxStatusFilterProps) => {
  const handleFilter = useCallback(
    (updated: string | string[]) => {
      const updatedTaxStatuses = (Array.isArray(updated) ? updated : [updated]) as TaxStatusEnum[];
      onFilter(updatedTaxStatuses);
    },
    [onFilter],
  );

  return (
    <SimpleFilter
      className={cn('inline-flex', className)}
      label={fieldName}
      items={TAX_STATUS_OPTIONS}
      initialSelected={selected}
      onFilter={handleFilter}
      closeOnOnlyClick={closeOnOnlyClick}
      isAdvanced={isAdvanced}
    />
  );
};

export default TaxStatusFilter;
